import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess";

export default async () => {
	// show more-less
	window.TextShowMoreLess = TextShowMoreLess;
	global.showMoreLessObjects = [];
	Array.from(document.querySelectorAll(".show-more-less-text-wrapper")).forEach(
		(div) => {
			const textShowMoreLess = new TextShowMoreLess(div);
			textShowMoreLess.init();

			global.showMoreLessObjects.push(textShowMoreLess);
		}
	);

	const ebMoreLessRootDiv = document.querySelector(
		"#eb-description-show-more-less"
	);
	// const disableButtons = true;
	if (ebMoreLessRootDiv) {
		const ebMoreLessInstance = new TextShowMoreLess(
			ebMoreLessRootDiv,
			window.screenSizeManager.screenType === "mobile" ? 1 : 1,
			".show-more-less-text",
			".read-more",
			".read-less",
			undefined,
			false
			// disableButtons
		);
		ebMoreLessInstance.init();
		global.showMoreLessObjects.push(ebMoreLessInstance);
	}

	const residenceMoreLessRootDiv = document.querySelector(
		"#residence-description-show-more-less"
	);
	if (residenceMoreLessRootDiv) {
		const disableButtons = true;
		const residenceMoreLessInstance = new TextShowMoreLess(
			residenceMoreLessRootDiv,
			window.screenSizeManager.screenType === "mobile" ? 4 : 10,
			".show-more-less-text",
			".read-more",
			".read-less",
			undefined,
			false,
			disableButtons
		);

		residenceMoreLessInstance.init();

		global.showMoreLessObjects.push(residenceMoreLessInstance);
	}
};
